/** @format */

module.exports = {
	title: "Inscrição cancelada",
	description:
		"Desculpe-nos pelo incômodo. Você não será mais notificado sobre novas atividades da plataforma Eagle-edu.",
};
